module.exports = __webpack_public_path__ + "assets/img/w3.34063d94.png";